import { KgdLogo } from "@/components/Layout";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function About() {
    return (
        <div>
            <section className="relative py-20 lg:py-28" style={{ background: "linear-gradient(160deg,#050F22,#0A2555)" }} data-theme="dark">
                <div className="max-w-4xl mx-auto px-5 lg:px-8">
                    <div className="eyebrow">À propos</div>
                    <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mt-4">Une maison d'entretien inspirée par la joaillerie</h1>
                    <p className="text-white/75 mt-6 text-lg">Ménage KGD — KGD S.E.N.C. accompagne les résidences et les entreprises de la Mauricie avec un service structuré, rigoureux et humain.</p>
                </div>
            </section>
            <section className="max-w-4xl mx-auto px-5 lg:px-8 py-16 space-y-10 text-slate-700 leading-relaxed">
                <div>
                    <h2 className="font-serif text-2xl text-[#071A33]">Notre promesse</h2>
                    <p className="mt-3 font-serif italic text-lg text-[#071A33]">« Un espace propre apaise l'esprit. »</p>
                    <p className="mt-3">Nous croyons que chaque espace mérite d'être traité avec soin, précision et constance — comme une pièce de joaillerie qu'on prend le temps de polir.</p>
                </div>
                <div>
                    <h2 className="font-serif text-2xl text-[#071A33]">Nos valeurs</h2>
                    <ul className="mt-4 grid sm:grid-cols-2 gap-3">
                        {["Confiance","Rigueur","Excellence","Constance","Tranquillité d'esprit"].map(v => (
                            <li key={v} className="border border-kgd-gold/30 rounded-lg px-4 py-3 bg-[#F7F8FA] text-[#071A33]">{v}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h2 className="font-serif text-2xl text-[#071A33]">Notre approche</h2>
                    <p className="mt-3">Chaque intervention commence par une écoute attentive de vos besoins. Nous élaborons ensuite une soumission personnalisée, adaptée à la réalité de votre espace, à votre rythme et à vos préférences. Nos équipes suivent une méthode structurée qui garantit une qualité constante d'une visite à l'autre.</p>
                </div>
                <div className="border-t border-kgd-gold/25 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <KgdLogo className="h-14" compact/>
                    <Link to="/soumission" className="btn-kgd" data-testid="about-cta"><Sparkles className="w-4 h-4"/> Planifier mon évaluation gratuite</Link>
                </div>
            </section>
        </div>
    );
}
